import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MaterialTable from '@material-table/core';
import { Button } from '@mui/material';
import { CsvBuilder } from 'filefy';
import jsPDF from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';
import { getPAExtensionTableData, currentData as currrentDataPAExtension } from '../Redux/CNS/PAExtensionsSlice';
import { getRejExtensionsTableData, currentData as currrentDataRejectedExtension } from '../Redux/CNS/RejectedExtensionsSlice';
import { getConfigurationsTableData, currentData as currrentDataConfiguration } from '../Redux/CNS/ConfigurationsSlice';
import { getMemberByPlanYearData, getMemberByPlanYearDataDownloadAll, currentData as membByPlanYear } from '../Redux/MNR/MemberByPlanYearSlice';
import { getGroupByYearAllData, getGroupByYearAllDataDownloadAll, currentData as groupByYearAll } from '../Redux/MNR/GroupByYearAllSlice';
import { getDupeQAData, getDupeQADataDownloadAll, currentData as DupeQA } from '../Redux/MNR/DupeQASlice';
import { getFormularyData, getFormularyDataDownloadAll, currentData as formulary } from '../Redux/MNR/FormularySlice';
import { getPACompoundDetailData, getPACompoundDetailDataDownloadAll, currentData as paCompound } from '../Redux/MNR/PACompoundDetailSlice';
import { getPAPriceDetailData, getPAPriceDetailDownloadAll, currentData as paPrice } from '../Redux/MNR/PAPriceDetailSlice';
import { getPriorAuthData, getPriorAuthDownloadAll, currentData as priorAuth } from '../Redux/MNR/PriorAuthSlice';
import { getProductDetailsData, getProductDetailsDownloadAll, currentData as productDetail } from '../Redux/MNR/ProductDetailSlice';
import { getCodeSetDetailsData, getCodeSetDetailsDownloadAll, currentData as codeSet } from '../Redux/MNR/CodeSetSlice';
import { getAccessToken } from '../Redux/TokenSlice';
import './Table.css';
applyPlugin(jsPDF);

function Table() {
    const dispatch = useDispatch();
    const tab = useSelector(state => state.tab.tab);
    const paExtensionData = useSelector(state => state.cnsPAExtensions.data);
    const rejectedExtensionData = useSelector(state => state.cnsRejectedExtensions.data);
    const configurationData = useSelector(state => state.cnsConfigurations.data);
    const membByPlanYearData = useSelector(state => state.memberByPlanYear.data);
    const groupByYearAllData = useSelector(state => state.groupByYearAll.data);
    const dupeQAData = useSelector(state => state.dupeQA.data);
    const formularyData = useSelector(state => state.formulary.data);
    const paCompoundData = useSelector(state => state.paCompound.data);
    const paPriceData = useSelector(state => state.paPrice.data);
    const priorAuthData = useSelector(state => state.priorAuth.data);
    const productDetailData = useSelector(state => state.productDetail.data);
    const codeSetData = useSelector(state => state.codeSet.data);
    const searchTriggered = useSelector(state => state.cnsCommon.searchTriggered);
    const columnData = useSelector(state => state.table.columns);
    const tableRef = useRef();
    const columns = columnData.map(col => ({ ...col }));
    const configError = useSelector(state => state.cnsConfigurations.error);
    const paExtError = useSelector(state => state.cnsPAExtensions.error);
    const mnrTab = useSelector(state => state.tab.mnrTab);
    const showAll = useSelector(state => state.mnrCommon.showAll);
    const isMNR = useSelector(state => state.mnrCommon.isMNR);
    const rejectedExtError = useSelector(state => state.cnsRejectedExtensions.error);
    const membByPlanYearError = useSelector(state => state.memberByPlanYear.error);
    const groupByYearAllError = useSelector(state => state.groupByYearAll.error);
    const dupeQAError = useSelector(state => state.dupeQA.error);
    const formularyError = useSelector(state => state.formulary.error);
    const paCompoundError = useSelector(state => state.paCompound.error);
    const paPriceError = useSelector(state => state.paPrice.error);
    const priorAuthError = useSelector(state => state.priorAuth.error);
    const productDetailError = useSelector(state => state.productDetail.error);
    const codeSetError = useSelector(state => state.codeSet.error);

    useEffect(() => {
        dispatch(getAccessToken());
        tableRef.current && tableRef.current.onQueryChange();
    }, [dispatch, searchTriggered, showAll]);

    if (configError || paExtError || rejectedExtError || membByPlanYearError || groupByYearAllError ||
        dupeQAError || formularyError || paCompoundError || paPriceError || priorAuthError
        || productDetailError || codeSetError) {
        return null;
    }

    const handleFetch = async (query, dataSource, getDataAction, updateAction, dataKey) => {
        let sortOrder = 'asc';
        //const pageSize = query.pageSize === 600 ? dataSource.totalCount : query.pageSize;
        const pageSize = query.pageSize
        sortOrder = query.orderDirection ? query.orderDirection : sortOrder;
        const columnName = query.orderBy?.title === undefined ? dataSource.columnName : query.orderBy?.title;

        const updatedData = {
            ...dataSource,
            sortOrder,
            columnName,
            pageSize,
            page: query.page
        };

        dispatch(updateAction(updatedData));

        try {
            const result = await dispatch(getDataAction(updatedData));
            const response = JSON.parse(result.payload);
            const data = response.data.data[dataKey];

            return {
                data: data.data, //.map(row => ({ ...row })), // Create mutable copies for Material-Table
                page: query.page,
                totalCount: data.totalCount
            };
        } catch (error) {
            throw error;
        }
    };

    const fetchData = (query) => {
        if (isMNR) {
            switch (mnrTab) {
                case 0:
                    return handleFetch(query, membByPlanYearData, getMemberByPlanYearData, membByPlanYear, 'GetMemberPlanYearAllDetails');
                case 1:
                    return handleFetch(query, groupByYearAllData, getGroupByYearAllData, membByPlanYear, 'GetEligibleGroupByPlanYearAllDetails');
                case 2:
                    return handleFetch(query, dupeQAData, getDupeQAData, DupeQA, 'GetMemberDupeQADetails');
                case 3:
                    return handleFetch(query, formularyData, getFormularyData, formulary, 'GetFormularyDetails');
                case 4:
                    return handleFetch(query, priorAuthData, getPriorAuthData, priorAuth, 'GetPriorAuthDetails');
                case 5:
                    return handleFetch(query, paCompoundData, getPACompoundDetailData, paCompound, 'GetPriorAuthCompoundDetails');
                case 6:
                    return handleFetch(query, paPriceData, getPAPriceDetailData, paPrice, 'GetPriorAuthPriceDetails');
                case 7:
                    return handleFetch(query, productDetailData, getProductDetailsData, productDetail, 'GetPriorAuthProductDetails');
                case 8:
                    return handleFetch(query, codeSetData, getCodeSetDetailsData, codeSet, 'GetProductCodeSetDetails');
                default:
                    return Promise.resolve({ data: [], page: 0, totalCount: 0 });
            }
        }
        else {
            switch (tab) {
                case 0:
                    return handleFetch(query, paExtensionData, getPAExtensionTableData, currrentDataPAExtension, 'GetPAExtensionDetails');
                case 1:
                    return handleFetch(query, rejectedExtensionData, getRejExtensionsTableData, currrentDataRejectedExtension, 'GetRejectedExtensionDetails');
                case 2:
                    return handleFetch(query, configurationData, getConfigurationsTableData, currrentDataConfiguration, 'GetDetails');
                case 3:
                    switch (mnrTab) {
                        case 0:
                            return handleFetch(query, membByPlanYearData, getMemberByPlanYearData, membByPlanYear, 'GetMemberPlanYearAllDetails');
                        case 1:
                            return handleFetch(query, groupByYearAllData, getGroupByYearAllData, membByPlanYear, 'GetEligibleGroupByPlanYearAllDetails');
                        case 2:
                            return handleFetch(query, dupeQAData, getDupeQAData, DupeQA, 'GetMemberDupeQADetails');
                        case 3:
                            return handleFetch(query, formularyData, getFormularyData, formulary, 'GetFormularyDetails');
                        case 4:
                            return handleFetch(query, priorAuthData, getPriorAuthData, priorAuth, 'GetPriorAuthDetails');
                        case 5:
                            return handleFetch(query, paCompoundData, getPACompoundDetailData, paCompound, 'GetPriorAuthCompoundDetails');
                        case 6:
                            return handleFetch(query, paPriceData, getPAPriceDetailData, paPrice, 'GetPriorAuthPriceDetails');
                        case 7:
                            return handleFetch(query, productDetailData, getProductDetailsData, productDetail, 'GetPriorAuthProductDetails');
                        case 8:
                            return handleFetch(query, codeSetData, getCodeSetDetailsData, codeSet, 'GetProductCodeSetDetails');
                        default:
                            return Promise.resolve({ data: [], page: 0, totalCount: 0 });
                    }

                default:
                    return Promise.resolve({ data: [], page: 0, totalCount: 0 });
            }
        }
    };

    const handleFetchDownloadAll = async (value, getDataAction, dataKey) => {
        try {
            const result = await dispatch(getDataAction(value));
            const response = JSON.parse(result.payload);
            const data = response.data.data[dataKey];
            return data.data;
        } catch (error) {
            throw error;
        }
    };

    const fetchDownLoadAll = () => {
        switch (mnrTab) {
            case 0:
                return handleFetchDownloadAll(membByPlanYearData, getMemberByPlanYearDataDownloadAll, 'GetAllMemberPlanYearAllDetails');
            case 1:
                return handleFetchDownloadAll(groupByYearAllData, getGroupByYearAllDataDownloadAll, 'GetAllEligibleGroupByPlanYearAllDetails');
            case 2:
                return handleFetchDownloadAll(dupeQAData, getDupeQADataDownloadAll, 'GetAllMemberDupeQADetails');
            case 3:
                return handleFetchDownloadAll(formularyData, getFormularyDataDownloadAll, 'GetFormularyDetails');
            case 4:
                return handleFetchDownloadAll(priorAuthData, getPriorAuthDownloadAll, 'GetPriorAuthDetails');
            case 5:
                return handleFetchDownloadAll(paCompoundData, getPACompoundDetailDataDownloadAll, 'GetPriorAuthCompoundDetails');
            case 6:
                return handleFetchDownloadAll(paPriceData, getPAPriceDetailDownloadAll, 'GetPriorAuthPriceDetails');
            case 7:
                return handleFetchDownloadAll(productDetailData, getProductDetailsDownloadAll, 'GetPriorAuthProductDetails');
            case 8:
                return handleFetchDownloadAll(codeSetData, getCodeSetDetailsDownloadAll, 'GetProductCodeSetDetails');
            default:
                return Promise.resolve({ data: [] });
        }
    }

    const handleShowAll = async (query, dataSource, getDataAction, updateAction, dataKey) => {
        let sortOrder = 'asc';
        //const pageSize = query.pageSize === 600 ? dataSource.totalCount : query.pageSize;
        const pageSize = query.pageSize
        sortOrder = query.orderDirection ? query.orderDirection : sortOrder
        const columnName = query.orderBy?.title === undefined ? dataSource.columnName : query.orderBy?.title;
        const updatedData = {
            ...dataSource,
            sortOrder,
            columnName,
            pageSize,
            page: query.page
        };

        dispatch(updateAction(updatedData));

        try {
            const result = await dispatch(getDataAction(updatedData));
            const response = JSON.parse(result.payload);
            const data = response.data.data[dataKey];

            return {
                data: data.data,//.map(row => ({ ...row })), // Create mutable copies for Material-Table       
                page: query.page,
                totalCount: data.totalCount
            };
        } catch (error) {
            throw error;
        }
    };

    const fetchShowAllData = (query) => {
        switch (mnrTab) {
            case 0:
                return handleShowAll(query, membByPlanYearData, getMemberByPlanYearData, membByPlanYear, 'GetMemberPlanYearAllDetails');
            case 1:
                return handleShowAll(query, groupByYearAllData, getGroupByYearAllData, groupByYearAll, 'GetEligibleGroupByPlanYearAllDetails');
            case 2:
                return handleShowAll(query, dupeQAData, getDupeQAData, DupeQA, 'GetMemberDupeQADetails');
            case 3:
                return handleShowAll(query, formularyData, getFormularyData, formulary, 'GetFormularyDetails');
            case 4:
                return handleShowAll(query, priorAuthData, getPriorAuthData, priorAuth, 'GetPriorAuthDetails');
            case 5:
                return handleShowAll(query, paCompoundData, getPACompoundDetailData, paCompound, 'GetPriorAuthCompoundDetails');
            case 6:
                return handleShowAll(query, paPriceData, getPAPriceDetailData, paPrice, 'GetPriorAuthPriceDetails');
            case 7:
                return handleShowAll(query, productDetailData, getProductDetailsData, productDetail, 'GetPriorAuthProductDetails');
            case 8:
                return handleShowAll(query, codeSetData, getCodeSetDetailsData, codeSet, 'GetProductCodeSetDetails');
            default:
                return Promise.resolve({ data: [], page: 0, totalCount: 0 });
        }
    }

    const exportCsv = (columns, data) => {
        const columnTitles = columns.map(columnDef => columnDef.title);
        const csvData = data.map(rowData => columns.map(columnDef => rowData[columnDef.field]));
        new CsvBuilder('data.csv')
            .setColumns(columnTitles)
            .addRows(csvData)
            .exportFile();
    };

    const exportPdf = (columns, data) => {
        const doc = new jsPDF({
            orientation: 'landscape',
        });
        const columnTitles = columns.map(columnDef => columnDef.title);
        const pdfData = data.map(rowData => columns.map(columnDef => rowData[columnDef.field]));
        doc.autoTable({
            head: [columnTitles],
            body: pdfData,
        });
        doc.save('data.pdf');
    };


    const exportMenuOptions = [
        {
            label: 'Export CSV',
            exportFunc: (cols, datas) => exportCsv(cols, datas),
        },
        {
            label: 'Export PDF',
            exportFunc: (cols, datas) => exportPdf(cols, datas),
        },
    ];

    // Filter based on MNR
    const filteredExportMenu = !isMNR
        ? exportMenuOptions
        : exportMenuOptions.filter(option => option.label !== 'Export PDF')


    return (
        (columns.length > 0 && !configError && !paExtError && !rejectedExtError && !membByPlanYearError) &&
        <div style={{ paddingTop: '24px' }}>
            <MaterialTable
                tableRef={tableRef}
                columns={columns}
                data={showAll === true ? fetchShowAllData : fetchData}
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {
                            (isMNR && mnrTab !== 4 && mnrTab !== 0 && mnrTab !== 1) &&
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={async () => {
                                    try {
                                        const data = await fetchDownLoadAll(); // Wait for data to be fetched
                                        exportCsv(columns, data);              // Then export to CSV
                                    } catch (error) {
                                        console.log('Download failed:', error);
                                    }
                                }}

                            >
                                Download All
                            </Button>
                        }
                    </div>
                }
                options={{
                    maxColumnSort: true,
                    pageSize: 50,
                    maxBodyHeight: '100%',
                    paginationType: 'stepped',
                    overflowY: 'visible',
                    paginationPosition: 'bottom',
                    pageSizeOptions: [50, 100, 200, 500],
                    emptyRowsWhenPaging: false,
                    //toolbar: tab === 3 ? true : false,
                    totalCount: true,
                    rowStyle: {
                        fontSize: 'var(--font-size-table)',
                        fontFamily: "'optum sans'",
                        border: '1px solid rgba(224, 224, 224, 1)',
                        textAlign: 'center'

                    },
                    headerStyle: {
                        fontSize: 'var(--font-size-table)',
                        fontWeight: 700,
                        fontFamily: "'optum sans'",
                        padding: '6px',
                        border: '1px solid rgb(68, 68, 68)',
                        borderTop: '.2em solid rgb(90,90,90)',
                        position: 'sticky',
                        top: 0,
                        backgroundColor: 'var(--primary-color)',
                        color: '#000C44',
                        //backgroundColor: 'var(--secondary-color)',
                        //color: '#fff',
                        textAlign: 'center',
                        //minWidth: 105
                    },
                    search: false,
                    setRowsPerPage: false,
                    exportMenu: filteredExportMenu
                    // exportMenu: [
                    //     {
                    //         label: 'Export CSV',
                    //         exportFunc: (cols, datas) => exportCsv(cols, datas),
                    //     },
                    //     {
                    //         label: 'Export PDF',
                    //         exportFunc: (cols, datas) => exportPdf(cols, datas),
                    //     },
                    // ],
                }}
            />
        </div>
    )

}

export default Table
